"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryFilteredTicketRankingWidgetDataSchema = void 0;
var zod_1 = require("zod");
var components_1 = require("../../components");
var CategoryFilteredTicketRankingMoreSchema = zod_1.z.object({
    action: zod_1.z
        .object({
        app: zod_1.z.string(),
        web: zod_1.z.string(),
    })
        .optional(),
    title: zod_1.z.string(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()),
});
var CategoryFilteredTicketRankingHeaderSchema = zod_1.z.object({
    title: zod_1.z.string(),
    icon: zod_1.z.string().optional(),
    subTitle: zod_1.z.string().optional(),
    more: CategoryFilteredTicketRankingMoreSchema.optional(),
});
var CategoryFilteredTicketRankingItemSchema = components_1.VerticalTicketItemSchema.extend({
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
var CategoryFilteredTicketRankingTabSchema = zod_1.z.object({
    header: CategoryFilteredTicketRankingHeaderSchema.optional(),
    items: zod_1.z.array(CategoryFilteredTicketRankingItemSchema),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
/**
 * [V1] 놀티켓 랭킹 위젯 - 응답 스키마 (YDM__NOL_CATEGORY_FILTERED_TICKET_RANKING__V1, v9.15.0~)
 *
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-display-api#tag/Widget/paths/~1widget~1v1~1category-filtered-ticket-ranking/get}
 */
exports.CategoryFilteredTicketRankingWidgetDataSchema = zod_1.z.object({
    header: CategoryFilteredTicketRankingHeaderSchema,
    items: zod_1.z.array(CategoryFilteredTicketRankingTabSchema),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).optional(),
});
